import React, { useEffect, useRef, useId } from 'react';
import { Box } from '@mui/material';
import mermaid from 'mermaid';

let mermaidInitialized = false;

function initMermaid() {
  if (mermaidInitialized) return;
  mermaid.initialize({
    startOnLoad: false,
    theme: 'neutral',
    securityLevel: 'strict',
    flowchart: { useMaxWidth: true, htmlLabels: true },
  });
  mermaidInitialized = true;
}

export default function FlowDiagram({ chart, title }) {
  const containerRef = useRef(null);
  const reactId = useId();
  const diagramId = `mermaid-${reactId.replace(/:/g, '')}`;

  useEffect(() => {
    if (!chart || !containerRef.current) return undefined;

    initMermaid();
    let cancelled = false;

    const render = async () => {
      try {
        const { svg } = await mermaid.render(diagramId, chart);
        if (!cancelled && containerRef.current) {
          containerRef.current.innerHTML = svg;
        }
      } catch (err) {
        if (!cancelled && containerRef.current) {
          containerRef.current.innerHTML = `<pre style="color:#b91c1c;font-size:12px;overflow:auto">${err.message}</pre>`;
        }
      }
    };

    render();
    return () => {
      cancelled = true;
    };
  }, [chart, diagramId]);

  if (!chart) return null;

  return (
    <Box
      sx={{
        my: 2,
        p: 2,
        bgcolor: '#fff',
        borderRadius: 2,
        border: '1px solid rgba(15,23,42,0.08)',
        overflow: 'auto',
      }}
      aria-label={title || 'Flow diagram'}
    >
      <Box ref={containerRef} sx={{ '& svg': { maxWidth: '100%', height: 'auto' } }} />
    </Box>
  );
}
